import { A02, A02Input, A02Output } from 'api/U015';
import { useEffect, useState } from 'react';

export function useLatestGetConsentHooks(
  input: A02Input
): [A02Output | undefined, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [consent, setConsent] = useState<A02Output>();
  const [err, setError] = useState<Error | null>(null);

  const fetchConsent = async (input: A02Input, cancellation: AbortSignal) => {
    return await A02(input, cancellation);
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const consent = await fetchConsent(input, cancellation);
        setConsent(consent);
      } catch (err) {
        console.error(err);
        setConsent(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, []);

  return [consent, loading, err];
}
